import { NgModule } from '@angular/core';
import { MailComponent } from '~shared/svgs/mail/mail.component';


@NgModule({
  declarations: [
    MailComponent
  ],
  exports: [
    MailComponent
  ]
})
export class MailModule {}
